<template>
  <h5 class="w-full pl-2 text-left text-2xs font-bold uppercase">
    {{ title }}
  </h5>
  <div
    v-if="contacts.length"
    class="my-3 grid grid-cols-1 gap-4"
  >
    <div
      v-for="(contact, index) in contacts"
      :key="index"
      class="flex flex-col justify-start self-center pl-2"
      :class="[
        { 'border-b-2 pb-2': needsBorder(++index) },
        index <= itemsToShow || showMore ? 'visible' : 'hidden',
      ]"
    >
      <p class="pl-2 text-left text-1md text-body-color">
        {{
          contact.value?.includes('@')
            ? `Email ${contact.value}`
            : `SMS Text Message ${formattedPhone(contact?.value)}`
        }}
      </p>
    </div>
  </div>
  <div
    v-else
    class="my-4 text-left"
  >
    <small class="text-body-color">No data found</small>
  </div>
  <div
    v-if="contacts.length > itemsToShow && showSeeMore"
    class="mb-4 flex justify-start"
  >
    <button-main
      size="md"
      class="cursor-pointer p-0 text-1md text-yellow-500 underline"
      variant="link"
      @click="toggleShowMore"
    >
      {{ showMore ? 'Show less' : 'Show more' }}
    </button-main>
  </div>
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import { formatPhoneParenthesis } from '@/common/validators';

export default {
  name: 'RequestRecipients',
  components: {
    ButtonMain,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    itemsToShow: {
      type: Number,
      default: 1,
    },
    contacts: {
      type: Array,
      default: () => [],
    },
    showSeeMore: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showMore: false,
      company_verification_method: {},
    };
  },
  computed: {
    formattedPhone() {
      return (phone) => {
        return formatPhoneParenthesis(phone);
      };
    },
  },
  methods: {
    needsBorder(index) {
      if (this.showMore) {
        return index !== this.contacts.length;
      }
      return index !== this.itemsToShow;
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    handleRadioClick(item) {
      const companyToVerify = {
        ...item,
        type: item.phone_e164 ? 'sms' : 'email',
      };
      this.company_verification_method = companyToVerify;
    },
  },
};
</script>
